<!--  -->
<template>
  <div class="homePage">
    <div class="Header">
      <div class="h_left">
        <div class="title">
          <div>HQS</div>
          <div style="border-top: 1px solid #606266; padding-top: 2px">
            AUTOMOTIVE
          </div>
        </div>
      </div>
      <div class="h_right">
        <div class="htex">
          <div>{{ objuserinfo.user.account }}</div>
        </div>
        <img src="@/assets/quit.png" alt="" @click="outSys" />
      </div>
    </div>
    <div class="home-page-body">
      <div class="tab-header">
        <div
          class="tab-item"
          :class="{ active: activeTab === 'inspection' }"
          @click="activeTab = 'inspection'"
        >
          Inspection Report
        </div>
        <div
          v-if="objuserinfo.clientResult && objuserinfo.clientResult.clientType.name === 'TESLA'"
          class="tab-item"
          :class="{ active: activeTab === 'audit' }"
          @click="activeTab = 'audit'"
        >
          Audit Report
        </div>
      </div>
      <div style="height: calc(100% - 1vh); display: flex">
        <div class="leftmenu">
          <div style="margin: 2vw 1vw 3vw 1vw">
            <el-form ref="form" :model="form">
              <el-col :span="14">
                <el-form-item>
                  <el-input @input="sortNumberInput" v-model="queryParams.sortNumber" placeholder="Sort No."
                    clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4"></el-col>
              <el-col :span="10">
                <el-form-item>
                  <el-button type="primary" size="mini" @click="SearchSortDataClick()"
                    style="margin-left: 1vw">Search</el-button>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
          <el-table :data="SortData" size="small" style="width: 100%; margin-top: 1vw; flex-grow: 1"
            :show-header="false" class="customer-table" @row-click="SortDataclick">
            <el-table-column prop="objsortNumber" label="" width="115">
            </el-table-column>
            <el-table-column prop="startDate" label="" width="100">
            </el-table-column>
          </el-table>
          <el-pagination class="fyys" small @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="currentPage2" :page-sizes="[12, 20, 30, 40]" :page-size="12" layout="prev, pager, next"
            :total="objtotal" :pager-count="5">
          </el-pagination>
        </div>
        <div class="rightmenu" v-if="activeTab === 'inspection'">
          <div class="r_tbys">
            <div class="r_lys">
              <div v-if="this.objDataDetail.sortTypeValue == 2" class="ztyss">
                SSORT0000{{ this.objDataDetail.sortNumber }}
              </div>
              <div v-else class="ztyss">
                TSORT0000{{ this.objDataDetail.sortNumber }}
              </div>

              <div class="delys" @click="ReportClick()" style="cursor: pointer">
                <i class="el-icon-edit" style="cursor: pointer"></i> Report
              </div>
            </div>
            <div class="r_rys">
              <div class="bdays">
                <div class="bdys">Business Date</div>
                <el-date-picker v-model="value1" type="daterange" range-separator="TO" start-placeholder="start"
                  end-placeholder="end" @change="value1change" :clearable="false">
                </el-date-picker>
              </div>
              <div style="margin-left: 20px">
                <el-button type="primary" size="mini" @click="SearchClick()">Search</el-button>
                <el-button size="mini" @click="ClearClick()">Clear</el-button>
              </div>
            </div>
          </div>
          <div class="xzysy">
            <span>Status:{{ this.objDataDetail.statusValue }}</span>
            <span>Client:{{ this.objDataDetail.clientName }}</span>
            <span>Start Date:{{ this.objDataDetail.startDate }}</span>
            <span>Category:{{ this.objDataDetail.sortCategoryValue }}</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="4">
              <div class="grid-content">
                <div class="klzt">{{ this.objDataDetail.total }}</div>
                <div class="zs_ys">Total</div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <div class="klzt">{{ this.objDataDetail.ok }}</div>
                <div class="ok_ys">OK</div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <div class="klzt">{{ this.objDataDetail.nok }}</div>
                <div class="nok_ys">NOK</div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <div class="klzt">{{ this.objDataDetail.rework }}</div>
                <div class="re_ys">Rework</div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <div class="klzt">{{ this.objDataDetail.fallout }}%</div>
                <div class="fa_ys">Fallout</div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">
                <div class="klzt">{{ this.objDataDetail.falloutRate }}%</div>
                <div class="be_ys">Fallout Rate Before Rework</div>
              </div>
            </el-col>
          </el-row>
          <el-table @row-click="SortDataDetailclick" :data="SortDataDetail" style="width: 100%; margin-top: 2vh"
            :header-cell-style="{
              background: '#FAFAFA',
              color: 'rgba(0, 0, 0, 0.65)',
            }">
            <el-table-column prop="businessDate" label="Date" width="180">
            </el-table-column>
            <el-table-column prop="partNumber" label="Part NO" width="180">
            </el-table-column>
            <el-table-column prop="locationName" label="location">
            </el-table-column>
            <el-table-column prop="ok" label="OK"> </el-table-column>
            <el-table-column prop="nok" label="NOK"> </el-table-column>
            <el-table-column prop="rework" label="Rework"> </el-table-column>
            <el-table-column prop="total" label="Total"> </el-table-column>
            <el-table-column prop="fallout" label="Fallout Rate(%)" :formatter="formatPercentage1">
            </el-table-column>
            <el-table-column prop="falloutRate" label="Fallout Rate Before Rework(%)" :formatter="formatPercentage2">
            </el-table-column>
          </el-table>
          <div class="block">
            <el-pagination @size-change="SortDetailhandleSizeChange" @current-change="SortDetailhandleCurrentChange"
              :current-page.sync="SortDetailcurrentPage2" :page-sizes="[100, 200, 300, 400]" :page-size="10"
              layout="prev, pager, next" :total="SortDetailobjtotal">
            </el-pagination>
          </div>
        </div>
        <div class="rightmenu" v-else-if="objuserinfo.clientResult && objuserinfo.clientResult.clientType.name === 'TESLA' && activeTab === 'audit'">
          <div class="r_tbys">
            <div class="r_lys">
              <div class="delys" @click="ReportClick()" style="cursor: pointer">
                <i class="el-icon-edit" style="cursor: pointer"></i> Report
              </div>
            </div>
            <div class="r_rys">
              <div class="bdays">
                <div class="bdys">Business Date</div>
                <el-date-picker v-model="value1" type="daterange" range-separator="TO" start-placeholder="start"
                  end-placeholder="end" @change="value1change" :clearable="false">
                </el-date-picker>
              </div>
              <div style="margin-left: 20px">
                <el-button type="primary" size="mini" @click="SearchClick()">Search</el-button>
                <el-button size="mini" @click="ClearClick()">Clear</el-button>
              </div>
            </div>
          </div>
          <el-row :gutter="20" style="margin-top: 3vh">
            <el-col :span="8">
              <div class="grid-content">
                <div class="klzt">{{ auditData.totalReport }}</div>
                <div class="zs_ys">Total Report</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content">
                <div class="klzt">{{ auditData.totalHc }}</div>
                <div class="zs_ys">Total HC</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content">
                <div class="klzt">{{ auditData.taskCompletionRate }}%</div>
                <div class="zs_ys">Task Completion Rate</div>
              </div>
            </el-col>
          </el-row>
          <el-table
            :data="auditData.list"
            style="width: 100%; margin-top: 2vh"
            @row-click="auditRowClick"
            :header-cell-style="{
              background: '#FAFAFA',
              color: 'rgba(0, 0, 0, 0.65)',
            }"
          >
            <el-table-column prop="businessDate" label="Business Date" width="180">
            </el-table-column>
            <el-table-column prop="locationName" label="Location">
            </el-table-column>
            <el-table-column prop="totalReport" label="Total Report">
            </el-table-column>
            <el-table-column prop="totalHc" label="Total HC">
            </el-table-column>
            <el-table-column prop="taskCompletionRate" label="Task Completion Rate">
            </el-table-column>
          </el-table>
          <div class="block audit-block">
            <span class="audit-total">Total: {{ auditData.total }}</span>
            <el-pagination
              @current-change="val => { auditQueryParams.pageNum = val; _loadAudit(); }"
              :current-page.sync="auditQueryParams.pageNum"
              :page-size="auditQueryParams.pageSize"
              layout="prev, pager, next"
              :total="auditData.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-drawer title="我是标题" :visible.sync="drawer" :direction="direction" :with-header="false">
      <div class="drawerContent">
        <template v-if="drawerMode === 'audit'">
          <div class="audit-drawer__header">
            <span class="audit-drawer__title">Audit List</span>
            <i class="el-icon-close audit-drawer__close" @click="drawer = false"></i>
          </div>
          <el-row :gutter="20" class="audit-drawer__meta">
            <el-col :span="12">
              <div class="audit-drawer__field">
                <span class="audit-drawer__label">Sort No. :</span>
                <span class="audit-drawer__value">{{ auditDrawer.sortNumber }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="audit-drawer__field">
                <span class="audit-drawer__label">Location:</span>
                <span class="audit-drawer__value">{{ auditDrawer.locationName }}</span>
              </div>
            </el-col>
          </el-row>
          <div
            v-for="(item, index) in auditDrawer.list"
            :key="item.id || index"
            class="audit-drawer__item"
          >
            <div class="audit-drawer__row">
              <span class="audit-drawer__label">Report Items:</span>
              <span class="audit-drawer__value">{{ item.auditor || '—' }}</span>
            </div>
            <div class="audit-drawer__row">
              <span class="audit-drawer__label">Shift:</span>
              <span class="audit-drawer__value">{{ item.shiftName || '—' }}</span>
            </div>
              <!-- <div class="audit-drawer__row">
                <span class="audit-drawer__label">Inspector:</span>
                <span
                  v-for="ins in item.inspectorList"
                  :key="ins.id"
                  class="audit-tag audit-tag--active"
                >{{ ins.inspectorName }}</span>
                <span
                  v-if="!item.inspectorList || !item.inspectorList.length"
                  class="audit-drawer__value"
                >—</span>
              </div> -->
            <div class="audit-drawer__row audit-drawer__row--block">
              <span class="audit-drawer__label">Report Items:</span>
              <div
                v-if="item.auditDetailList && item.auditDetailList.length"
                class="audit-drawer__report-list"
              >
                <div
                  v-for="detail in item.auditDetailList"
                  :key="detail.id"
                  class="audit-drawer__report-item"
                >
                  <el-checkbox
                    v-model="detail._checked"
                    disabled
                    class="audit-drawer__report-checkbox"
                  />
                  <span class="audit-drawer__report-text">{{ detail.value }}</span>
                </div>
              </div>
              <span v-else class="audit-drawer__value">—</span>
            </div>
            <div class="audit-drawer__row">
              <span class="audit-drawer__label">Pictures:</span>
            </div>
            <div class="audit-drawer__photos">
              <el-image
                v-for="url in item.pictureUrls"
                :key="url"
                fit="cover"
                :src="url"
                :preview-src-list="item.pictureUrls"
              ></el-image>
            </div>
          </div>
        </template>
        <el-form v-else ref="form" :model="form" label-width="80px">
          <el-row :gutter="20">
            <el-col :span="12">
              <div>
                <span class="wtys">Date:</span><span>{{ objSortDataDetail.businessDate }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="wtys">OK:</span><span>{{ objSortDataDetail.ok }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div>
                <span class="wtys">Part No:</span><span>{{ objSortDataDetail.partNumber }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="wtys">NOK:</span><span>{{ objSortDataDetail.nok }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div>
                <span class="wtys">Location:</span><span>{{ objSortDataDetail.locationName }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="wtys">Rework:</span><span>{{ objSortDataDetail.rework }}</span>
              </div>
            </el-col>
          </el-row>
          <el-collapse v-model="activeNames" v-if="drawerMode === 'sn'" class="sn-collapse">
            <el-collapse-item v-for="(item, index) in snNokList" :key="item.id || index" :name="index">
              <template slot="title">
                <span class="sn-collapse__sn">SN:{{ item.sn }}</span>
              </template>
              <div v-if="item.reasonText" class="sn-collapse__reason">NOK Reason:{{ item.reasonText }}</div>
              <div class="demo-image__lazy" style="width: 100%">
                <el-image fit="fill" style="width: 160px; height: 120px; padding: 1vw 1vw 1vw 1vw"
                  v-for="url in item.urlList" :key="url" :src="url" :preview-src-list="[url]"></el-image>
              </div>
            </el-collapse-item>
          </el-collapse>

          <el-collapse v-model="activeNames" v-else>
            <el-collapse-item v-for="(item, index) in objSortDataDetail.nokData" :key="index" :name="index">
              <template slot="title"> {{ item.nokReason }} </template>
              <div class="demo-image__lazy" style="width: 100%">
                <el-image fit="fill" style="width: 100px; height: 100px; padding: 1vw 1vw 1vw 1vw"
                  v-for="url in item.urlList" :key="url" :src="url" :preview-src-list="[url]"></el-image>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import objstorage from "@/common/localstorage/storage.js";
import objaxios from "axios";
import objurl from "@/common/interface/url.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      activeTab: "inspection",
      activeNames: [0], // 默认展开第一个面板
      drawer: false,
      direction: "rtl",
      drawerMode: "legacy", // legacy: nokReason+urlList; sn: snList mode
      snNokList: [],
      objuserinfo: {},
      queryParams: {
        pageNum: 1,
        pageSize: 12,
        sortNumber: null,
      },
      objtotal: 0,
      currentPage2: 1,
      SortDetailqueryParams: {
        pageNum: 1,
        pageSize: 10,
        businessDateEnd: "",
        businessDateStart: "",
        sortId: "",
      },
      SortDetailobjtotal: 0,
      SortDetailcurrentPage2: 1,
      index: "",
      form: {
        sortNumber: "",
      },
      SortData: [],
      value1: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
      SortDataDetail: [],
      objDataDetail: {},
      objSortDataDetail: {},
      auditQueryParams: {
        pageNum: 1,
        pageSize: 10,
        sortId: "",
      },
      auditData: {
        totalReport: 0,
        totalHc: 0,
        taskCompletionRate: "0%",
        list: [],
        total: 0,
      },
      auditDrawer: { sortNumber: "", locationName: "", list: [] },
    };
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    SortDataDetailclick(row, column, event) {
      console.log(row);
      console.log(column);
      console.log(event);
      this.objSortDataDetail = row;
      this.drawer = true;
      this.drawerMode = "legacy";
      this.snNokList = [];
      this.activeNames = [0];

      var _this = this;
      objaxios.defaults.headers.common["Authorization"] =
        objstorage.get("userinfo").tokenHead + objstorage.get("userinfo").token;
      objaxios
        .post(objurl.report_selectNokPhoto, this.objSortDataDetail)
        .then(function (res) {
          if (res.data.code == 200) {
            const OSS_BASE = "https://hqsautomotive.oss-us-west-1.aliyuncs.com/";
            const list = Array.isArray(res.data.data) ? res.data.data : [];
            const hasSnList = list.some(
              (d) => Array.isArray(d && d.snList) && d.snList.length > 0
            );

            if (hasSnList) {
              _this.drawerMode = "sn";
              const snItems = [];
              list.forEach((group) => {
                const snList = Array.isArray(group && group.snList)
                  ? group.snList
                  : [];
                snList.forEach((snItem) => {
                  const reasons = Array.isArray(snItem && snItem.snReasonList)
                    ? snItem.snReasonList
                    : [];
                  const pictures = Array.isArray(snItem && snItem.snPictureList)
                    ? snItem.snPictureList
                    : [];

                  snItems.push({
                    id: snItem && snItem.id,
                    sn: snItem && snItem.sn,
                    reasonText: reasons
                      .map((r) => (r && (r.dictValue || r.dictKey)) || "")
                      .filter(Boolean)
                      .join(", "),
                    urlList: pictures
                      .map((p) => (p && p.picture) || "")
                      .filter(Boolean)
                      .map((p) => OSS_BASE + p),
                  });
                });
              });
              _this.snNokList = snItems;
              _this.activeNames = snItems.length > 0 ? [0] : [];
            } else {
              _this.drawerMode = "legacy";
              list.forEach((val) => {
                const urls = Array.isArray(val && val.urlList) ? val.urlList : [];
                val.urlList = urls
                  .filter(Boolean)
                  .map((p) => OSS_BASE + p);
              });
              _this.objSortDataDetail.nokData = list;
              _this.activeNames = list.length > 0 ? [0] : [];
            }

            _this.$forceUpdate();
          } else if (res.data.code == 401) {
            _this.$message.error(res.data.message);
            objstorage.remove("userinfo");
            _this.$router.replace("/");
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ReportClick() {
      var _this = this;
      const isAudit = this.activeTab === "audit";
      if (isAudit && !this.auditQueryParams.sortId) return;
      objaxios.defaults.headers.common["Authorization"] =
        objstorage.get("userinfo").tokenHead + objstorage.get("userinfo").token;
      objaxios({
        method: "post",
        url: isAudit ? objurl.audit_export : objurl.record_export,
        data: isAudit
          ? {
              startBusinessDate: this.formatDateToday(this.value1[0]),
              endBusinessDate: this.formatDateToday(this.value1[1]),
              sortId: this.auditQueryParams.sortId,
              pageNum: this.auditQueryParams.pageNum,
              pageSize: this.auditQueryParams.pageSize,
            }
          : this.SortDetailqueryParams,
        responseType: "blob",
      })
        .then((response) => {
          // _this.download(response)
          if (!response) return;
          const blob = new Blob([response.data], {
            type: "application/vnd.ms-excel",
          }); // 构造一个blob对象来处理数据，并设置文件类型
          if (window.navigator.msSaveOrOpenBlob) {
            //兼容IE10
            navigator.msSaveBlob(blob, this.filename);
          } else {
            const href = URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
            const contentDisposition = response.headers["content-disposition"]; // 从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
            console.log("contentDisposition");
            console.log(contentDisposition);
            const patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
            console.log(patt);
            const result = patt.exec(contentDisposition);
            console.log(result);
            // const filename = decodeURI(escape(result[1])) // 处理文件名,解决中文乱码问题
            let filename = result[1].toString(); // 处理文件名,解决中文乱码问题
            filename = filename.substr(1);
            filename = filename.substr(0, filename.length - 1);

            // const filename ="aaaaa.xlsx"
            console.log(filename);
            let objectUrl = window.URL.createObjectURL(
              new Blob([response.data])
            );
            const elink = document.createElement("a");
            console.log(elink);
            elink.download = filename; //下载文件名称,
            elink.style.display = "none";
            elink.href = objectUrl;
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
            window.URL.revokeObjectURL(elink.href); // 释放URL 对象
          }
        })
        .catch((error) => { });
    },
    ClearClick() {
      if (this.activeTab === "audit") {
        this.auditData = {
          totalReport: 0,
          totalHc: 0,
          taskCompletionRate: "0%",
          list: [],
          total: 0,
        };
        this.auditQueryParams.pageNum = 1;
        this._initSortDataTime();
        return;
      }

      this.objDataDetail.total = 0;
      this.objDataDetail.ok = 0;
      this.objDataDetail.nok = 0;
      this.objDataDetail.rework = 0;
      this.objDataDetail.fallout = 0;
      this.objDataDetail.falloutRate = 0;
      this.SortDataDetail = [];
      this.SortDetailcurrentPage2 = 1;
      this.SortDetailobjtotal = 0;
      // this.SortDetailqueryParams={
      //   pageNum: 1,
      //   pageSize: 10,
      //   businessDateEnd: '',
      //   businessDateStart: '',
      //   sortId: ''
      // }
      this._initSortDataTime();
    },
    SearchClick() {
      if (this.activeTab === "audit") {
        if (!this.auditQueryParams.sortId) return;
        this.auditQueryParams.pageNum = 1;
        this._loadAudit();
        return;
      }

      this.objDataDetail.total = 0;
      this.objDataDetail.ok = 0;
      this.objDataDetail.nok = 0;
      this.objDataDetail.rework = 0;
      this.objDataDetail.fallout = 0;
      this.objDataDetail.falloutRate = 0;
      this.SortDataDetail = [];
      this._initSortDataDetail();
    },
    SearchSortDataClick() {
      var _this = this;
      _this.SortData = [];
      this.queryParams.pageNum = 1;
      this.currentPage2 = 1;
      _this.SortDataOne();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.queryParams.pageNum = val;
      this._initSortData();
    },
    SortDetailhandleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    SortDetailhandleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.SortDetailqueryParams.pageNum = val;
      this._initSortDataDetail();
    },
    outSys() {
      var _this = this;
      objaxios.defaults.headers.common["Authorization"] =
        objstorage.get("userinfo").tokenHead + objstorage.get("userinfo").token;
      objaxios
        .post(objurl.user_logout)
        .then(function (res) {
          if (res.data.code == 200) {
            objstorage.remove("userinfo");
            _this.$router.replace("/");
          } else if (res.data.code == 401) {
            _this.$message.error(res.data.message);
            objstorage.remove("userinfo");
            _this.$router.replace("/");
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    Groupbtn() {
      var _this = this;
      _this.$router.push("/group");
      objstorage.set("pageindex", "5-1");
    },
    _initData() {
      var _this = this;
      this.objuserinfo = objstorage.get("userinfo");
      _this._initSortDataTime();
    },
    sortNumberInput() { },
    formatPercentage1(row, column) {
      return row.fallout + "%";
    },
    formatPercentage2(row, column) {
      return row.falloutRate + "%";
    },
    formatDateToday(myDate) {
      //获取当前时间并打印
      let wk = myDate.getDay();
      let yy = String(myDate.getFullYear());
      let mm = String(
        myDate.getMonth() + 1 < 10
          ? "0" + (myDate.getMonth() + 1)
          : myDate.getMonth() + 1
      );
      let dd = String(
        myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate()
      );
      let hou = String(
        myDate.getHours() < 10 ? "0" + myDate.getHours() : myDate.getHours()
      );
      let min = String(
        myDate.getMinutes() < 10
          ? "0" + myDate.getMinutes()
          : myDate.getMinutes()
      );
      let sec = String(
        myDate.getSeconds() < 10
          ? "0" + myDate.getSeconds()
          : myDate.getSeconds()
      );
      let weeks = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      let week = weeks[wk];
      // this.objdatenow = yy + ' 年 ' + mm + ' 月 ' + dd + ' 日'
      // this.objdatenow = hou + ' : ' + min + ' : ' + sec
      // this.nowWeek = week
      var time = yy + "-" + mm + "-" + dd;
      return time;
    },
    _initSortData() {
      var _this = this;
      objaxios.defaults.headers.common["Authorization"] =
        objstorage.get("userinfo").tokenHead + objstorage.get("userinfo").token;
      objaxios
        .post(objurl.sort_find, _this.queryParams)
        .then(function (res) {
          if (res.data.code == 200) {
            _this.SortData = res.data.data.list;

            _this.SortData.forEach((val, index) => {
              if (val.sortTypeValue == 2) {
                val.objsortNumber = "SSORT" + val.sortNumber;
              } else {
                val.objsortNumber = "TSORT" + val.sortNumber;
              }
            });

            _this.objtotal = parseInt(res.data.data.total);
          } else if (res.data.code == 401) {
            _this.$message.error(res.data.message);
            objstorage.remove("userinfo");
            _this.$router.replace("/");
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    value1change() {
      console.log(this.value1);
      this.SortDetailqueryParams.businessDateStart = this.formatDateToday(
        this.value1[0]
      );
      this.SortDetailqueryParams.businessDateEnd = this.formatDateToday(
        this.value1[1]
      );
    },
    _initSortDataTime() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      this.value1 = [start, end];
      this.SortDetailqueryParams.businessDateStart = this.formatDateToday(
        this.value1[0]
      );
      this.SortDetailqueryParams.businessDateEnd = this.formatDateToday(
        this.value1[1]
      );
    },
    _initSortDataDetail() {
      var _this = this;
      objaxios.defaults.headers.common["Authorization"] =
        objstorage.get("userinfo").tokenHead + objstorage.get("userinfo").token;
      objaxios
        .post(objurl.sort_detail, _this.SortDetailqueryParams)
        .then(function (res) {
          if (res.data.code == 200) {
            _this.SortDataDetail = res.data.data.list;
            _this.SortDetailobjtotal = parseInt(res.data.data.total);

            // _this.objDataDetail.objTotal = 0
            // _this.objDataDetail.objOK = 0
            // _this.objDataDetail.objNOK = 0
            // _this.objDataDetail.objRework = 0

            // _this.SortDataDetail.forEach((val, index) => {

            //   _this.objDataDetail.objTotal += val.total
            //   _this.objDataDetail.objOK += val.ok
            //   _this.objDataDetail.objNOK += val.nok
            //   _this.objDataDetail.objRework += val.rework

            // })
            // _this.objDataDetail.objFallout = ((_this.objDataDetail.objNOK / _this.objDataDetail.objTotal) * 100).toFixed(2) == "NaN" ? 0 : ((_this.objDataDetail.objNOK / _this.objDataDetail.objTotal) * 100).toFixed(2) + '%'
            // _this.objDataDetail.objFalloutRate = (((_this.objDataDetail.objNOK + _this.objDataDetail.objRework) / _this.objDataDetail.objTotal) * 100).toFixed(2) == "NaN" ? 0 : (((_this.objDataDetail.objNOK + _this.objDataDetail.objRework) / _this.objDataDetail.objTotal) * 100).toFixed(2) + '%'

            objaxios.defaults.headers.common["Authorization"] =
              objstorage.get("userinfo").tokenHead +
              objstorage.get("userinfo").token;
            objaxios
              .post(objurl.record_statistics, _this.SortDetailqueryParams)
              .then(function (ress) {
                if (ress.data.code == 200) {
                  // _this.objDataDetail=res.data.data
                  _this.objDataDetail.fallout = ress.data.data.fallout;
                  _this.objDataDetail.falloutRate = ress.data.data.falloutRate;
                  _this.objDataDetail.nok = ress.data.data.nok;
                  _this.objDataDetail.ok = ress.data.data.ok;
                  _this.objDataDetail.rework = ress.data.data.rework;
                  _this.objDataDetail.total = ress.data.data.total;
                  _this.$forceUpdate();
                } else if (ress.data.code == 401) {
                  _this.$message.error(ress.data.message);
                  objstorage.remove("userinfo");
                  _this.$router.replace("/");
                } else {
                  _this.$message.error(ress.data.message);
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          } else if (res.data.code == 401) {
            _this.$message.error(res.data.message);
            objstorage.remove("userinfo");
            _this.$router.replace("/");
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    SortDataclick(row, column, event) {
      console.log(row);
      this.objDataDetail = row;

      if (this.activeTab === "audit") {
        this.auditQueryParams.sortId = String(row.id);
        this.auditQueryParams.pageNum = 1;
        this._loadAudit();
        return;
      }

      this.SortDetailqueryParams.sortId = row.id;
      this._initSortDataDetail();
    },

    SortDataOne() {
      var _this = this;
      objaxios.defaults.headers.common["Authorization"] =
        objstorage.get("userinfo").tokenHead + objstorage.get("userinfo").token;
      objaxios
        .post(objurl.sort_find, _this.queryParams)
        .then(function (res) {
          if (res.data.code == 200) {
            _this.SortData = res.data.data.list;
            _this.SortData.forEach((val, index) => {
              if (val.sortTypeValue == 2) {
                val.objsortNumber = "SSORT" + val.sortNumber;
              } else {
                val.objsortNumber = "TSORT" + val.sortNumber;
              }
            });
            _this.objtotal = parseInt(res.data.data.total);
            if (_this.SortData.length > 0) {
              _this.SortDataclick(_this.SortData[0]);
            }
          } else if (res.data.code == 401) {
            _this.$message.error(res.data.message);
            objstorage.remove("userinfo");
            _this.$router.replace("/");
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    _loadAudit() {
      var _this = this;
      if (!_this.auditQueryParams.sortId) return;
      const dateParams = {
        startBusinessDate: _this.formatDateToday(_this.value1[0]),
        endBusinessDate: _this.formatDateToday(_this.value1[1]),
        sortId: _this.auditQueryParams.sortId,
      };
      objaxios.defaults.headers.common["Authorization"] =
        objstorage.get("userinfo").tokenHead + objstorage.get("userinfo").token;
      objaxios
        .post(objurl.audit_statistics, dateParams)
        .then(function (res) {
          if (res.data.code == 200) {
            const data = res.data.data || {};
            _this.auditData.totalReport = data.totalReport || 0;
            _this.auditData.totalHc = data.totalHc || 0;
            _this.auditData.taskCompletionRate = data.taskCompletionRate || "0%";
          } else if (res.data.code == 401) {
            _this.$message.error(res.data.message);
            objstorage.remove("userinfo");
            _this.$router.replace("/");
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      objaxios
        .post(objurl.audit_statistics_page, {
          ...dateParams,
          pageNum: _this.auditQueryParams.pageNum,
          pageSize: _this.auditQueryParams.pageSize,
        })
        .then(function (res) {
          if (res.data.code == 200) {
            _this.auditData.list = res.data.data.list || [];
            _this.auditData.total = parseInt(res.data.data.total) || 0;
          } else if (res.data.code == 401) {
            _this.$message.error(res.data.message);
            objstorage.remove("userinfo");
            _this.$router.replace("/");
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    isDetailYes(detail) {
      if (!detail) return false;
      var completion = detail.completion;
      if (completion && typeof completion === "object") {
        var name = String(completion.name || "").trim().toUpperCase();
        if (name === "YES" || name === "NO") return name === "YES";
        return completion.value === 1 || completion.value === "1";
      }
      if (detail.completionValue === 1 || detail.completionValue === "1") return true;
      if (detail.completionValue === 0 || detail.completionValue === "0") return false;
      return String(completion || "").trim().toUpperCase() === "YES";
    },
    auditRowClick(row) {
      var _this = this;
      this.drawerMode = "audit";
      this.drawer = true;
      this.auditDrawer = {
        sortNumber: "",
        locationName: row.locationName || "",
        list: [],
      };
      objaxios.defaults.headers.common["Authorization"] =
        objstorage.get("userinfo").tokenHead + objstorage.get("userinfo").token;
      objaxios
        .post(objurl.audit_list, {
          businessDate: row.businessDate,
          locationId: String(row.locationId),
          sortId: this.auditQueryParams.sortId,
        })
        .then(function (res) {
          if (res.data.code == 200) {
            const OSS_BASE = "https://hqsautomotive.oss-us-west-1.aliyuncs.com/";
            const list = Array.isArray(res.data.data) ? res.data.data : [];
            list.forEach(function (item) {
              item.auditDetailList = (item.auditDetailList || []).map(function (d) {
                return Object.assign({}, d, { _checked: _this.isDetailYes(d) });
              });
              item.pictureUrls = (item.pictureList || [])
                .map(function (p) {
                  return p && p.picture;
                })
                .filter(Boolean)
                .map(function (p) {
                  return OSS_BASE + p;
                });
            });
            _this.auditDrawer.list = list;
            if (list.length > 0) {
              _this.auditDrawer.sortNumber = list[0].sortNumber || "";
              _this.auditDrawer.locationName =
                list[0].locationName || row.locationName || "";
            }
          } else if (res.data.code == 401) {
            _this.$message.error(res.data.message);
            objstorage.remove("userinfo");
            _this.$router.replace("/");
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this._initData();
    this.SortDataOne();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    //location.reload()
    if (location.href.indexOf("#reloaded") == -1) {
      location.href = location.href + "#reloaded";
      location.reload();
    }
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang='stylus' rel='stylesheet/stylus'>
// @import url(); 引入公共css类
.homePage {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  .customer-table th {
    border: none;
  }

  .el-table {
    overflow: scroll;
  }

  // 去除表格各种边框
  .customer-table td, .customer-table th.is-leaf {
    border: none;
  }

  // 表格最外边框
  .el-table--border, .el-table--group {
    border: none;
  }

  // 头部边框
  .customer-table thead tr th.is-leaf {
    border: 1px solid #EBEEF5;
    border-right: none;
  }

  .customer-table thead tr th:nth-last-of-type(2) {
    border-right: 1px solid #EBEEF5;
  }

  // 表格最外层边框-底部边框
  .el-table--border::after, .el-table--group::after {
    width: 0;
  }

  .customer-table::before {
    width: 0;
  }

  .customer-table .el-table__fixed-right::before, .el-table__fixed::before {
    width: 0;
  }

  // 表格有滚动时表格头边框
  .el-table--border th.gutter:last-of-type {
    border: 1px solid #EBEEF5;
    border-left: none;
  }

  // 去除边框线
  /deep/ .el-table::before {
    height: 0;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #2751be;
    border-radius: 6px;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 8px; // 横向滚动条
    height: 25px; // 纵向滚动条 必写
    background: #12244d;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 10px; /* 滚动条的背景区域的圆角 */
    background-color: rgb(18, 36, 77); /* 滚动条的背景颜色 */
  }

  .el-menu-vertical-demo {
    z-index: 999;
    background: rgb(11, 26, 40);
    width: 14vw;
    height: 100%;
    text-align: left;
    overflow: hidden;

    .el-menu el-menu--inline {
      background: rgb(11, 26, 40);
    }

    .el-menu-item-group {
      background: rgb(11, 26, 40);
    }

    .el-submenu__title {
      color: #ffffff;
    }

    .el-submenu .el-submenu__title:hover {
      background: rgb(11, 26, 40);
    }

    .el-menu-item:focus, .el-menu-item:hover {
      outline: 0;
      background: rgb(11, 26, 40);
    }

    .el-menu-item {
      color: #ffffff;
    }

    .el-submenu .el-menu-item {
      min-width: 40px;
      background: rgb(11, 26, 40);
      font-size: 12px;
      width: 40px;
      color: #ffffff;
    }
  }

  .Header {
    height: 8vh;
    min-height: 77px;
    padding: 0 2vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    background: rgb(11, 26, 40);

    .h_left {
      display: flex;
      align-items: center;
    }

    .h_right {
      white-space: nowrap;
      display: flex;
      align-items: center;

      img {
        width: 1.5vw;
        height: 1.5vw;
      }

      .htex {
        margin: 0 1.5vw;
        font-size: 12px;
      }
    }

    .collpase {
      margin-right: 1vw;
    }
  }

  .home-page-body {
    height: calc(100% - 14vh);
    padding: 3vh;

    .tab-header {
      display: flex;
      align-items: center;
      height: 6vh;
      gap: 2vw;

      .tab-item {
        font-size: 24px;
        font-weight: 800;
        color: rgba(39, 60, 94, 0.45);
        cursor: pointer;
        padding-bottom: 0.5vh;
        border-bottom: 3px solid transparent;
        transition: color 0.2s, border-color 0.2s;

        &.active {
          color: rgb(39, 60, 94);
          border-bottom-color: rgb(39, 60, 94);
        }

        &:hover {
          color: rgb(39, 60, 94);
        }
      }
    }

    .btys {
      display: flex;
      align-items: center;
      height: 6vh;
      font-size: 24px;
      font-weight: 800;
      color: rgb(39, 60, 94);
    }

  .leftmenu {
  position: relative;
  height: 100%;
  width: 14vw;
  color: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  min-width: 200px !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-top: 2vw; /* 仅保留顶部整体内边距，控制与容器顶部的距离 */

  // 搜索框区域：彻底清零上下多余间距
  > div:first-child {
    margin: 0 1vw 0 1vw !important; /* 上下margin全清，仅留左右间距 */
    padding: 0 !important; /* 清除可能的内置padding */
  }

  // 表格样式：穿透清除组件内置间距
  .el-table {
    width: 100%;
    flex-grow: 1;
    overflow: auto;
    overflow-x: hidden;
    margin: 0 !important; /* 彻底清除表格自身margin */
    border-top: none !important; /* 去掉表格顶部边框间隙 */
  }

  // 穿透清除Element UI表格的默认内边距和边框间距
  /deep/ .el-table__header-wrapper,
  /deep/ .el-table__body-wrapper {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }

  /deep/ .el-table__cell {
    padding-top: 8px !important; /* 可调整单元格内边距，不影响整体间距 */
    padding-bottom: 8px !important;
  }

  // 分页样式（保持不变）
  .fyys {
    margin-top: 1vw;
    margin-bottom: 1vw;
    align-self: flex-end;
    padding-right: 1vw;
  }

  .el-table__body tr:hover>td {
    background-color: rgb(39, 60, 94) !important;
    color: #fff;
    font-weight: 800;
  }
}

    .rightmenu {
      // 修改分页垂直居中在表格中间的问题
      // start
      // position: relative;
      display: flex;
      flex-direction: column;
      // end
      padding: 1.5vw 2vh;
      flex: 1;
     // overflow-y: scroll;
      border: 1px solid #e8e8e8;
      border-left: none;
      border-radius: 10px;
      margin-left:5px;

      .r_tbys {
        display: flex;
        justify-content: space-between;
        
        .r_lys {
          display: flex;

          .ztyss {
            font-size: 24px;
            font-weight: 800;
            color: rgb(39, 60, 94);
            margin-right: 16px;
          }

          .delys {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 60px;
            height: 30px;
            border-radius: 6px;
            background: rgb(39, 60, 94);
            color: #ffffff;
            font-size: 12px;
          }
        }

       

        .r_rys {
  display: flex;
  align-items: center;
  
  .bdays {
    display: flex;
    align-items: center;
    
    .bdys {
      font-size: 14px;
      margin-right: 10px;
      white-space: nowrap; /* 防止文字换行 */
    }
    
    /* 修复日期选择器样式 */
    .el-date-editor {
      width: 280px; /* 设置足够宽度 */
      min-width: 280px;
      
      .el-range-separator {
        width: 30px; /* 确保分隔符有足够空间 */
        padding: 0 5px;
        box-sizing: content-box;
      }
    }
  }
}
      }

      .xzysy {
        display: flex;
        font-size: 12px;
        margin: 3vh 0;

        span {
          margin-right: 4vw;
        }
      }

      .grid-content {
        border-radius: 2vw;
        border: 1px solid #e8e8e8;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 1vw 1vw;
        height: 80px;

        .klzt {
          font-size: 24px;
          font-weight: 800;
          color: rgb(39, 60, 94);
          margin-bottom: 1vh;
        }

        .ok_ys, .nok_ys, .re_ys, .fa_ys, .be_ys, .zs_ys {
          font-size: 14px;
        }

        .zs_ys {
          color: rgb(39, 60, 94);
        }

        .ok_ys {
          color: #76ac76;
        }

        .nok_ys {
          color: red;
        }

        .re_ys {
          color: #e6aa62;
        }

        .fa_ys {
          color: #5fa8dd;
        }

        .be_ys {
          color: #b98aea;
          text-align: center;
        }
      }

      .content {
        width: 100%;
        height: 100%;
        background: rgb(11, 26, 40);
        float: left;
        margin: 1.5vw;
        min-width: 855px;
        min-height: 650px;
        margin-top: 2vh;
      }
    }
  }

 .block {
  margin-top: 0.5vh; /* 从 0.5vh 调整为 2vh，数值越大往下移动越多 */
  display: flex;
  justify-content: end;
}

  .audit-block {
    justify-content: space-between;
    align-items: center;

    .audit-total {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .el-drawer, .rtl {
    min-width: 400px;
    width: 40% !important;
  }

  .drawerContent {
    padding: 2vw 2vw 0 2vw;
    margin-bottom: 10vw;
  }

  .sn-collapse__sn {
    font-weight: 600;
  }

  .sn-collapse__reason {
    margin-top: 6px;
    line-height: 1.35;
    word-break: break-word;
  }

  .audit-drawer__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .audit-drawer__title {
    font-size: 20px;
    font-weight: 700;
    color: rgb(39, 60, 94);
  }

  .audit-drawer__close {
    font-size: 18px;
    cursor: pointer;
    color: #909399;
  }

  .audit-drawer__meta {
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e8e8e8;
  }

  .audit-drawer__field {
    line-height: 28px;
  }

  .audit-drawer__label {
    font-size: 16px;
    font-weight: 700;
    color: rgb(39, 60, 94);
    margin-right: 6px;
  }

  .audit-drawer__value {
    font-size: 14px;
    font-weight: 400;
    color: #606266;
  }

  .audit-drawer__item {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;
  }

  .audit-drawer__row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 14px;
    line-height: 28px;
  }

  .audit-drawer__row .audit-drawer__label {
    flex-shrink: 0;
  }

  .audit-drawer__row--block {
    flex-direction: column;
    align-items: flex-start;
    flex-wrap: nowrap;
  }

  .audit-drawer__report-list {
    width: 100%;
    margin-top: 4px;
  }

  .audit-drawer__report-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    line-height: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .audit-drawer__report-checkbox {
    margin-right: 10px;

    &.is-disabled .el-checkbox__inner {
      border-color: #b0b8c4;
      background-color: #fff;
    }

    &.is-disabled.is-checked .el-checkbox__inner {
      background-color: #fff;
      border-color: rgb(39, 60, 94);

      &::after {
        border-color: rgb(39, 60, 94);
      }
    }
  }

  .audit-drawer__report-text {
    font-size: 14px;
    color: #8a96a8;
  }

  .audit-tag {
    display: inline-block;
    margin: 4px 8px 4px 0;
    padding: 2px 10px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    font-size: 12px;
    color: #909399;
  }

  .audit-tag--active {
    border-color: rgb(39, 60, 94);
    color: rgb(39, 60, 94);
  }

  .audit-drawer__photos {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    margin-top: 12px;

    .el-image {
      width: 100%;
      height: 100px;
    }
  }

  .el-row {
    margin-bottom: 1vw;
  }


  
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue